// extracted by mini-css-extract-plugin
export default {"NumberInput":"StyledNumericInput_NumberInput__xRmWa"};